module.exports = "/_next/static/images/blankmonitoralt-6fabcaa0a3a95925ca989ec88b1549eb.svg";